import Modal from "../../../components/general/Modal";
import {
  Conditional,
  Content,
  Item,
  Options,
  Wrapper,
  WrapperRef,
  Button,
  Popper,
  DivIcon,
  ConditionalContainer,
  ConfirmContainer,
  Header,
  Title,
  ConditionalDiv,
  Footer,
  EdgeLabel,
} from "./styles";
import Xarrow, { Xwrapper } from "react-xarrows";
import { useDispatch, useSelector } from "react-redux";
import ButtonConditional from "../../../assets/icons/ButtonConditional";
import { Fragment, useCallback, useEffect, useState } from "react";
import Close from "../../../assets/icons/Close";
import FlowIcon from "../../../assets/icons/FlowIcon";
import MouseIcon from "../../../assets/icons/MouseIcon";
import { useStoreState } from "react-flow-renderer";
import { handleConfirmTask } from "../../../state/activedFlows/actions";
import { toastAlert } from "../../../components/Toastify/index";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import ReactLoading from "react-loading";
import { getNodeById } from "../../../state/activedFlows/selectors";
import { useGantt } from "../../../hooks/useGantt";
export function ConditionalModal({
  isOpen,
  onClose,
  selector,
  className,
  nodeId,
}) {
  const pane = useSelector((state) => state.activedFlows.pane);
  const flow = pane?.flow;
  const [actual, setActual] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [task, setTask] = useState(null);

  const edges = useStoreState((state) => state.edges);
  const nodes = useStoreState((state) => state.nodes);

  const [options, setOptions] = useState({ nodes: [], edges: [] });

  const dispatch = useDispatch();
  const conditional = useSelector((state) =>
    getNodeById(state, nodeId.current),
  );

  const { loadGantt } = useGantt();

  const { promiseInProgress } = usePromiseTracker({
    area: "active-conditional",
  });

  async function confirmTask() {
    //task é o next node e conditional é o node atual
    const conditionalEdge = edges.find(
      (item) => item.target === task.id && item.source === conditional.id,
    );
    if (!conditionalEdge) {
      toastAlert({
        msg: "Houve um erro ao confirmar condicional: Aresta não encontrada",
        isError: true,
      });
      setConfirmModal(false);
      onClose();
      return;
    }

    await trackPromise(
      dispatch(
        handleConfirmTask({
          flowId: task.flowId,
          taskId: conditional._id,
          edgeId: conditionalEdge._id,
        }),
      ).then((res) => {
        const newElements = res.payload.flow.elements;
        toastAlert({ msg: `Tarefa: ${task.label} em EXECUÇÃO!` });
        // loadGantt(newElements, task.flowId);
        loadGantt(newElements, flow._id, flow.flowStatus, flow.createdAt);
        setConfirmModal(false);
        onClose();
      }),
      "active-conditional",
    );
  }

  useEffect(() => {
    if (!isOpen) {
      setConfirmModal(false);
      nodeId.current = null;
      setTask(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const getNodes = useCallback(
    (nodeId) => {
      if (nodeId.current) {
        const filteredEdges = edges.filter(
          (edge) => edge.source === nodeId.current,
        );

        const connectedNodes = nodes.filter((node) =>
          filteredEdges.some((edge) => edge.target === node.id),
        );

        const sortedNodes = [...connectedNodes].sort(
          (a, b) => a.position.y - b.position.y,
        );

        const sortedEdges = [...filteredEdges].sort((a, b) => {
          const indexOfA = sortedNodes.findIndex(
            (node) => node.id === a.target,
          );
          const indexOfB = sortedNodes.findIndex(
            (node) => node.id === b.target,
          );
          return indexOfA - indexOfB;
        });

        setOptions({
          nodes: sortedNodes,
          edges: sortedEdges,
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [nodeId, nodes, edges],
  );

  useEffect(() => {
    getNodes(nodeId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  //Possíveis opções depois de uma condicional
  //Tarefa, condicional, condicional-fim, paralelo, temporizador

  const getEdgeLabel = (i) =>
    options.edges[i] ? options.edges[i].data.text.toUpperCase() : null;

  const updateNodeConfirm = (item) => {
    const type = item.type;

    const label = item.data.label
      ? item.data.label.toUpperCase()
      : type === "parallel"
        ? `PARALELO`
        : type === "conditional"
          ? `CONDICIONAL`
          : type === "conditionalEnd"
            ? `CONDICIONAL FIM`
            : type === "timerEvent"
              ? `TEMPORIZADOR`
              : undefined; // Or some other default value

    setTask({ label, flowId: item.flowId, id: item.id });
    setActual(null);
  };

  return (
    options && (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        selector={selector}
        className={className}
        topOffset={confirmModal ? "20%" : "0"}
        darker
      >
        {confirmModal ? (
          <ConfirmContainer confirm={confirmModal}>
            <DivIcon style={{ top: "1.0875rem", right: "0.875rem" }}>
              <Close onClick={onClose} />
            </DivIcon>
            <Header>
              <FlowIcon />
              <strong>Confirmar condicional do fluxo</strong>
            </Header>
            <Title>Deseja seguir com o fluxo pelo caminho selecionado?</Title>
            {!promiseInProgress ? (
              <>
                <ConditionalDiv>
                  <div>
                    <MouseIcon />

                    <span>{task.label.toUpperCase()}</span>
                  </div>
                </ConditionalDiv>
                <Footer>
                  <button
                    onClick={() => setConfirmModal(false)}
                    className="cancelButton"
                  >
                    Cancelar
                  </button>
                  <button onClick={confirmTask} className="confirmButton">
                    Confirmar
                  </button>
                </Footer>
              </>
            ) : (
              <div
                style={{
                  margin: "0 auto",
                  padding: "4rem",
                }}
              >
                <ReactLoading type="bars" color="#118052" />
              </div>
            )}
          </ConfirmContainer>
        ) : (
          <ConditionalContainer>
            <DivIcon>
              <Close onClick={() => onClose()} />
            </DivIcon>
            <Content>
              <Wrapper id="conditionalElement">
                <Popper isOpen={isOpen}>
                  <span>
                    Escolha o caminho da condicional que deseja seguir no fluxo
                  </span>
                </Popper>
                <Conditional />
                <WrapperRef />
                <EdgeLabel status={true}>
                  <p>{conditional ? conditional.data.label : null}</p>
                </EdgeLabel>
              </Wrapper>
              <Options>
                <Xwrapper>
                  {options.nodes.map((item, i) => (
                    <Fragment key={i + "_item"}>
                      <Item
                        onMouseEnter={() => setActual(i)}
                        onMouseLeave={() => setActual(null)}
                        onClick={() => {
                          setConfirmModal(true);

                          updateNodeConfirm(item);
                        }}
                      >
                        <Button id={"elem" + i}>
                          <ButtonConditional
                            key={i + "_conditional"}
                            height="0.6rem"
                          />
                        </Button>

                        <span>{getEdgeLabel(i)}</span>
                      </Item>

                      <div
                        className={actual === i ? "xArrowLight" : "xArrowDark"}
                      >
                        <Xarrow
                          key={i + "_arrow"}
                          color="#40e5a0"
                          style
                          showHead={false}
                          strokeWidth={4}
                          startAnchor="left"
                          endAnchor="right"
                          path="grid"
                          gridBreak="15%"
                          start={"elem" + i} //or an id
                          end={"conditionalElement"} //can be react ref
                        />
                      </div>
                    </Fragment>
                  ))}
                </Xwrapper>
              </Options>
            </Content>
          </ConditionalContainer>
        )}
      </Modal>
    )
  );
}
